var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn === false)?_c('main',[(_vm.appLogin === false)?_c('PageIntro',{attrs:{"heading":'Sign in with your <span>' +
      _vm.configStrings.clubName +
      ' ' +
      _vm.configStrings.productName +
      '</span> ',"body":'<p>Sign in below to your ' +
      _vm.configStrings.clubName +
      ' ' +
      _vm.configStrings.productName +
      ' for seamless access to exclusive content.</p><p>If you haven’t created an account yet click to register below. One time registration required with your email.</p>'}}):_vm._e(),_c('Login'),(_vm.appLogin === false)?_c('FooterShout',{attrs:{"type":'register'}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }